module.exports = __webpack_public_path__ + "img/150.983b8aa1.jpg";